export const financeStatementsColumns = [
  {
    field: "year",
    headerName: "Year",
    flex: 0.8,
    sortComparator: (a, b) => {
    const toNum = (val) => {
      if (!val || val === "—") return 0;
      return parseInt(String(val), 10) || 0;
    };
    return toNum(a) - toNum(b);
  },
  },
  {
    field: "quarter",
    headerName: "Quarter",
    flex: 0.8,
  },
  {
    field: "reportingCurrency",
    headerName: "Reporting Currency",
    flex: 1,
  },

  {
    field: "revenue",
    headerName: "Revenue",
    flex: 1,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "grossMargin",
    headerName: "Gross Margin",
    flex: 1,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "ebitda",
    headerName: "EBITDA",
    flex: 1,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "arr",
    headerName: "ARR",
    flex: 1,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "cashBalance",
    headerName: "Net Cash Balance",
    flex: 1.2,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "runway",
    headerName: "Runway",
    flex: 1,
    align: "right",
    headerAlign: "right",
  },
];